import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

@Injectable({ providedIn: 'root' })
export class DeviceService {
    constructor(private _platform: Platform) {}

    /**
     * Get device information
     */
    getDeviceInfo(): {
        deviceType: string;
        os_version: string;
    } {
        let deviceType = 'desktop';
        let os_version = 'unknown';

        if (!this._platform.isBrowser) {
            return { deviceType: 'unknown', os_version: 'unknown' };
        }

        const userAgent = navigator.userAgent;

        // Detect device type
        if (this._platform.IOS || /iPad|iPhone|iPod/.test(userAgent)) {
            deviceType = 'ios';
        } else if (this._platform.ANDROID || /Android/.test(userAgent)) {
            deviceType = 'android';
        } else if (/Windows/.test(userAgent)) {
            deviceType = 'windows';
        } else if (/Mac/.test(userAgent)) {
            deviceType = 'mac';
        } else if (/Linux/.test(userAgent)) {
            deviceType = 'linux';
        } else {
            deviceType = 'desktop';
        }

        // Extract OS version
        if (this._platform.IOS) {
            const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (match) {
                os_version = `iOS ${match[1]}.${match[2]}${match[3] ? '.' + match[3] : ''}`;
            } else {
                os_version = 'iOS';
            }
        } else if (this._platform.ANDROID) {
            const match = userAgent.match(/Android (\d+(?:\.\d+)?)/);
            if (match) {
                os_version = `Android ${match[1]}`;
            } else {
                os_version = 'Android';
            }
        } else if (/Windows NT (\d+\.\d+)/.test(userAgent)) {
            const match = userAgent.match(/Windows NT (\d+\.\d+)/);
            if (match) {
                const version = match[1];
                const versionMap: { [key: string]: string } = {
                    '10.0': 'Windows 10/11',
                    '6.3': 'Windows 8.1',
                    '6.2': 'Windows 8',
                    '6.1': 'Windows 7',
                };
                os_version = versionMap[version] || `Windows ${version}`;
            } else {
                os_version = 'Windows';
            }
        } else if (/Mac OS X (\d+[._]\d+)/.test(userAgent)) {
            const match = userAgent.match(/Mac OS X (\d+[._]\d+)/);
            if (match) {
                os_version = `macOS ${match[1].replace('_', '.')}`;
            } else {
                os_version = 'macOS';
            }
        } else if (/Linux/.test(userAgent)) {
            os_version = 'Linux';
        } else {
            os_version = navigator.platform || 'unknown';
        }

        return {
            deviceType,
            os_version,
        };
    }
}

